export const LANGUAGES = [
  {
    code: "en",
    name: "English",
    nativeName: "English",
    flag: "🇺🇸",
  },
  {
    code: "ja",
    name: "Japanese",
    nativeName: "日本語",
    flag: "🇯🇵",
  },
  {
    code: "zh-TW",
    name: "Traditional Chinese",
    nativeName: "繁體中文",
    flag: "🇹🇼",
  },
  {
    code: "zh-CN",
    name: "Simplified Chinese",
    nativeName: "简体中文",
    flag: "🇨🇳",
  },
  {
    code: "it",
    name: "Italian",
    nativeName: "Italiano",
    flag: "🇮🇹",
  },
  {
    code: "de",
    name: "German",
    nativeName: "Deutsch",
    flag: "🇩🇪",
  },
  {
    code: "th",
    name: "Thai",
    nativeName: "ไทย",
    flag: "🇹🇭",
  },
  {
    code: "ko",
    name: "Korean",
    nativeName: "한국어",
    flag: "🇰🇷",
  },
];

export const DEFAULT_LANGUAGE = "en";

export const SUPPORTED_LANGUAGE_CODES = LANGUAGES.map((lang) => lang.code);

export const getLanguageByCode = (code) => {
  return LANGUAGES.find((lang) => lang.code === code);
};
